import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';

import './scss/index.scss';
import PDF from '../component/pdf';
import StaticPage from '../component/static-page';
import WelfareBudget from './component/welfare-budget';
import moIndex from '../store';
import HeadPdf from '../component/head-pdf';
import Title from '../component/title';
import FootPdf from '../component/foot-pdf';
import Portrait from './component/portrait';
import Human from './component/human';
import HolidayTable from './component/key-holiday-table';
import moWelfare from './store';
import SectionBoundary from '../component/section-boundary';
import { isEmpty } from 'lodash';

interface IProps {}
interface IState {}

const WealfareInsightPdf = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { PerCapitaWelfareDate, PerWelfareDistributionDate, keyHolidayTable } =
    moWelfare;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="wealfare-insight-pdf-warps">
      {(PerCapitaWelfareDate[0] ||
        PerCapitaWelfareDate[1] ||
        PerCapitaWelfareDate[2] ||
        !isEmpty(PerWelfareDistributionDate) ||
        !isEmpty(keyHolidayTable)) && <StaticPage
        url="https://file.smartsalary.cn/index-pdf/07.png"
        head={true}
        showuuid={false}
        onetitle="人力资源核心指标"
        twotitle={moIndex.industry.name}/>}
      {(PerCapitaWelfareDate[0] ||
        PerCapitaWelfareDate[1] ||
        PerCapitaWelfareDate[2] ||
        !isEmpty(PerWelfareDistributionDate)) && (
        <SectionBoundary name="福利洞察-人均福利预算">
          <PDF>
            <section className="budget-pdf-warp">
              <HeadPdf
                onetitle="人力资源核心指标"
                twotitle={moIndex.industry.name}/>
              <section className="budget-top-title">
                {!isEmpty(PerCapitaWelfareDate) && (
                  <Title title="企业预算 - 人均福利预算" bigTitle="福利洞察" />
                )}
                {!isEmpty(PerCapitaWelfareDate) && <WelfareBudget />}
                {!isEmpty(PerWelfareDistributionDate) && (
                  <section style={{ marginTop: '40px' }}>
                    <Title
                      title="企业预算 - 人均福利预算分布"
                      bigTitle="福利洞察"/>
                  </section>
                )}
                {!isEmpty(PerWelfareDistributionDate) && <Portrait />}
              </section>
              <FootPdf />
            </section>
          </PDF>
        </SectionBoundary>
      )}

      {!isEmpty(keyHolidayTable) && (
        <SectionBoundary name="福利洞察-重点节日福利">
          <PDF>
            <section className="holiday-pdf-warp">
              <HeadPdf
                onetitle="人力资源核心指标"
                twotitle={moIndex.industry.name}/>
              <section className="holiday-top-title">
                <Title title="企业预算 - 重点节日人均福利" bigTitle="福利洞察" />
                <Human />
                <HolidayTable />
              </section>
              <FootPdf />
            </section>
          </PDF>
        </SectionBoundary>
      )}
    </section>
  );
};

export default observer(WealfareInsightPdf);
